module.exports = __webpack_public_path__ + "assets/0ce5b3216055092cc381b4381b42888a.mp4";